import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=8ff34604&scoped=true"
import script from "./Keywords.vue?vue&type=script&lang=js"
export * from "./Keywords.vue?vue&type=script&lang=js"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=8ff34604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff34604",
  null
  
)

export default component.exports